import { render, staticRenderFns } from "./integral-particulars.vue?vue&type=template&id=638ba34d&"
import script from "./integral-particulars.vue?vue&type=script&lang=js&"
export * from "./integral-particulars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports